import { render, staticRenderFns } from "./StoermeldungenIcon.vue?vue&type=template&id=4edc0ed1&scoped=true&"
var script = {}
import style0 from "./StoermeldungenIcon.vue?vue&type=style&index=0&id=4edc0ed1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edc0ed1",
  null
  
)

export default component.exports